import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCamSq = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "30px",
	height: "30px",
	viewBox: "0 0 30 30",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title === undefined ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: "cam"
		}) : title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Page-1",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "cam",
				transform: "translate(2.000000, 6.000000)",
				fill: "#5B1954",
				fillRule: "nonzero",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M17.25,2.88 L17.25,14.38 C17.2445137,15.9627792 15.9627792,17.2445137 14.38,17.25 L2.88,17.25 C1.29331699,17.25 0.00550931597,15.9666734 3.19744231e-16,14.38 L3.19744231e-16,2.88 C3.19744231e-16,1.28941992 1.28941992,0 2.88,0 L14.38,0 C15.9666734,0.00550931597 17.25,1.29331699 17.25,2.88 Z M15.810035,2.88 C15.8126643,2.49901075 15.6631811,2.13271036 15.3947147,1.86236663 C15.1262484,1.59202291 14.7609986,1.43996474 14.38,1.43996474 L2.88,1.43996474 C2.49727118,1.43731408 2.1294389,1.58816528 1.85880209,1.85880209 C1.58816528,2.1294389 1.43731408,2.49727118 1.43996474,2.88 L1.43996474,14.38 C1.43996474,14.7609986 1.59202291,15.1262484 1.86236663,15.3947147 C2.13271036,15.6631811 2.49901075,15.8126643 2.88,15.810035 L14.38,15.810035 C15.1697672,15.810035 15.810035,15.1697672 15.810035,14.38 L15.810035,2.88 Z M25.8800056,2.88 L25.8800056,14.33 C25.8815003,14.8796809 25.5822207,15.3861542 25.1,15.65 C24.8964659,15.7566929 24.6697973,15.8116429 24.44,15.8100358 C24.143537,15.8084205 23.854381,15.7178415 23.61,15.55 L19,12.32 C18.7700458,12.1814969 18.6362387,11.9265679 18.6528652,11.6586395 C18.6694916,11.3907112 18.8337904,11.1542813 19.0791041,11.0452713 C19.3244179,10.9362613 19.6100047,10.9727755 19.82,11.14 L24.44,14.37 L24.44,2.88 L19.82,6.11 C19.6100047,6.27722447 19.3244179,6.31373874 19.0791041,6.20472869 C18.8337904,6.09571865 18.6694916,5.85928878 18.6528652,5.59136045 C18.6362387,5.32343212 18.7700458,5.0685031 19,4.93 L23.61,1.7 C24.0500113,1.3896391 24.6264136,1.35069437 25.1041744,1.59904581 C25.5819353,1.84739725 25.8812227,2.34154633 25.8800056,2.88 L25.8800056,2.88 Z",
					id: "Shape"
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgCamSq);
export default ForwardRef;
